import _ from "lodash";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from "semantic-ui-react";
import { taricDuty } from '../../../../commonApis';
import {
  addItemsTabWarnings,
  deleteItemsTabWarnings
} from '../../../commonActions/serverErrorAction';
import { CommodityField } from "../../../commonComponents/formComponents/CommodityCodeField";
import DropDown from "../../../commonComponents/formComponents/dropDown";
import InputField from "../../../commonComponents/formComponents/inputField";
import { createLineItemDuty, createSupportingDocsInfo, removeLineItemDuty, removeSupportingDocLineInfo, saveLineItemFeild, updateLineItemFeild } from '../../actions';
import { getValidationError as ValidationError } from '../../Helper';
import { COUNTRY_ORIGIN,PREFERENCE,REDUCTION} from '../../Helper/formLabel';
import usePdiEnable from "../../hooks/usePdiEnable";

 function MerchForm2(props) {
   const dispatch = useDispatch()
   const {
     lineItemIndex,
     commodityCode,
     exciseCode,
     additionalCode1,
     additionalCode2,
     countryOfOrigin,
     box36Preference,
     box36Reduction,
     tariffRegime,
     isFormDisabled,
     invoiceIndex,
     tariffRegimeSuffix,
     translate,
     specialCountryKeys,
     exciseCodes,
     isImportShipment,
     serviceType,
     taricCode,
     htsCode,
     merchandiseId,
     invoiceId,
     destinationCountry,
     originProvince,
     originProvinceKeys,
     customValue,
     unitCount,
     statValue
   } = props

  const [length, setLength] = useState(htsCode.length)
  const [htsMetaData, setHtsMetaData] = useState({})
  const [showModal, setShowModal] = useState(false)
  const merchData = useSelector(state => state.InvoicesReducer.invoices[invoiceIndex].merchandiseList[lineItemIndex]);
  const unitCodes = useSelector((state) => state.DropDownValues.unitCodes)
  const exemptedCode = useSelector((state) => state.DropDownValues.TARRIF_EXEMPT_DOC_LIST_FROM_DELETE)
  // const { additionalInfo, itemDuties } = merchData;
  const htsInputRef = useRef(null)
   const taricInputRef = useRef(null)
   
useEffect(() => {
  if (document.activeElement === htsInputRef.current && length >= 8) taricInputRef.current.focus()
}, [length])

const getValidationError=(field, value, Level, onlyMandatoryCheck)=>ValidationError(field, value, Level, onlyMandatoryCheck,serviceType,translate)


const addErrors = (level, value, fieldName) => dispatch(addItemsTabWarnings(level, value, fieldName))

const deleteErrors = (level, value, fieldName) => dispatch(deleteItemsTabWarnings(level, value, fieldName))

const updateData = useCallback((...args) => dispatch(updateLineItemFeild(...args)), [])
   
const saveData = useCallback((...args) => dispatch(saveLineItemFeild(...args)), [])

const addError = useCallback(() => {
  addErrors(
    'itemsTab',
    `invoice - 00${invoiceIndex + 1} :: line ${lineItemIndex + 1}.` + ' :: Invalid Commodity Code.',
    `commodityCode-${merchandiseId}`
  )
}, [])
   
const [isAddingInfo, setIsAddingInfo] = useState(false)
const [isAddingDuty, setIsAddingDuty] = useState(false)

const updateAddInfoStatus = useCallback(() => {
  setIsAddingInfo(false)
}, [isAddingInfo])

const updateAddDutyStatus = useCallback(() => {
  setIsAddingDuty(false)
}, [isAddingDuty])

  ////  const addDuties = useCallback(
  ////    (taricData, merchandiseId, invoiceId, customValue, dutyRate) => {
  ////      const { dutyMeasures, totalDutyAndTaxes } = taricData
  ////      const updateAddDutyStatus = () => {}
  ////      dutyMeasures?.map((duty) => {
  ////        const payload = {
  ////          taxRate: duty.dutyExpression?.slice(0, -1)?.replace(',', '.'),
  ////          taxAmount: Number(duty.dutyAmount?.amount).toFixed(2),
  ////          taxBase: customValue,
  ////          taxType: duty.taxType,
  ////        }
  ////        dispatch(createLineItemDuty(merchandiseId, invoiceId, updateAddDutyStatus, payload))
  ////      })
  ////      totalDutyAndTaxes &&
  ////        (updateData(invoiceId, merchandiseId, { statValue: (Number(totalDutyAndTaxes?.amount) + Number(customValue))?.toFixed(2) }),
  ////          saveData(merchandiseId, 'statValue', invoiceId));
  ////      dutyRate?.duty &&
  ////        dispatch(
  ////          createLineItemDuty(merchandiseId, invoiceId, updateAddDutyStatus, {
  ////            taxRate: dutyRate?.duty?.slice(0, -1),
  ////            taxType: dutyRate?.taxType,
  ////            taxBase: (Number(totalDutyAndTaxes?.amount || 0) + Number(customValue))?.toFixed(2),
  ////            taxAmount: (
  ////              (Number(dutyRate?.duty?.slice(0, -1)) *
  ////                (Number(totalDutyAndTaxes?.amount || 0) + Number(customValue))) /
  ////              100
  ////            ).toFixed(2),
  ////          })
  ////        )
  ////    },
  ////    [destinationCountry,updateData,saveData]
  ////  )
  ////  let addTaxes = useCallback((dutyRate)=>{taricDuty({
  ////     shipmentType: serviceType,
  ////     destinationCountry,
  ////     countryOfOrigin,
  ////     commodityCode,
  ////     customValue,
  ////     unitCount,
  ////   }).then((res) => {
  ////     let response = res?.data?.eventMessage;
  ////     (response?.code !== 500 || response?.code !== 400) &&
  ////       addDuties(response, merchandiseId, invoiceId,customValue,dutyRate)
  ////   })
  ////  }, [merchandiseId, invoiceId, customValue, commodityCode])

   const removeAllDocsAndTaxes =
     () => {
       return (dispatch, getState) => {
         const {additionalInfo, itemDuties} = getState().InvoicesReducer.invoices[invoiceIndex].merchandiseList[lineItemIndex]
         console.log({ additionalInfo, exemptedCode })
         let docs = additionalInfo?.filter(item=>!exemptedCode.some(code=>item.code === code.value))
         const deleteStatus = () => {}
         itemDuties?.forEach((tax) =>dispatch(removeLineItemDuty(tax.merchandiseId, tax.merchandiseDutyId, invoiceId, deleteStatus)))
         docs?.forEach((doc) =>dispatch(removeSupportingDocLineInfo({tableName:"additionalInfo",fieldIdName:"infoId",invoiceId,merchandiseId,id:doc.infoId})))
     }
     }

const submit = useCallback(
  (payload) => {
    let { dutyRate, preference, antiDumping, supUnitType, controls, additionalCode1,exciseCodeVal,vatDuty } = payload
    let preferences = preference[0] ?preference[0]?.slice(0,1):''
    let reductions =  preference[0] ?preference[0]?.slice(1):''
    let additionalCode2 = antiDumping[0]?antiDumping[0]:''
    let doc = []
    doc.push(preference[2])
    doc.push(antiDumping[2])
    doc.push(controls[2])
    let duties = []
    // duties.push(dutyRate)
    duties.push(preference[1])
    duties.push(antiDumping[1])
    const pref = box36Preference?.filter((e) => e.value === preferences)[0]?.value
    const red = box36Reduction?.filter((e) => e.value === reductions)[0]?.value
    const supUnit = unitCodes?.find((unit) => unit.value === supUnitType)?.value || '';
    let docs = doc?.filter(Boolean)
    duties = duties?.filter(Boolean)

    
    dispatch(removeAllDocsAndTaxes(docs))
    docs?.forEach((doc) => dispatch(createSupportingDocsInfo(invoiceIndex, lineItemIndex, merchandiseId, invoiceId, updateAddInfoStatus, doc)));
    dispatch(updateLineItemFeild(invoiceId, merchandiseId, {
        // unitType,
        supUnits: supUnit,
        tariffRegime: pref ? pref : merchData.tariffRegime,
        tariffRegimeSuffix: red ? red : merchData.tariffRegimeSuffix,
        additionalCode1: additionalCode1 ? additionalCode1 : additionalCode2,
        additionalCode2: additionalCode1 ? additionalCode2 : '',
        exciseCode:exciseCodeVal
        // commercialDescription: description?.slice(0, 250),
    }))
    
    dispatch(saveLineItemFeild(merchandiseId, ['unitType', 'supUnits', 'tariffRegime', 'tariffRegimeSuffix', 'commercialDescription', 'additionalCode1', 'additionalCode2','exciseCode'], invoiceId))
    
    if (isImportShipment) {
      dutyRate &&  dispatch(
        createLineItemDuty(merchandiseId, invoiceId, updateAddDutyStatus, {
          taxRate: dutyRate?.slice(0, -1),
          taxType: 'A00',
          taxBase: customValue,
          taxAmount: (
            (Number(dutyRate?.slice(0, -1)) * Number(customValue)) /
            100
          ).toFixed(2),
        })
      )
      duties?.forEach((dutyRate) =>
        dispatch(
          createLineItemDuty(merchandiseId, invoiceId, updateAddDutyStatus, {
            taxRate: dutyRate?.slice(0, -1),
            taxType: 'A30',
            taxBase: customValue,
            taxAmount: (
              (Number(dutyRate?.slice(0, -1)) * Number(customValue)) /
              100
            ).toFixed(2),
          })
        )
      )

      if(!!vatDuty){
      dispatch(
        createLineItemDuty(merchandiseId, invoiceId, updateAddDutyStatus, {
          taxRate: vatDuty,
          taxType: 'B00',
          taxBase: statValue,
          taxAmount: (
            (Number(vatDuty) * Number(statValue)) /
            100
          ).toFixed(2),
        })
      )
      }

      if(!!exciseCodeVal){
      dispatch(
        createLineItemDuty(merchandiseId, invoiceId, updateAddDutyStatus, {
          taxRate: '',
          taxType: exciseCodeVal,
          taxBase: '',
          taxAmount: ''
        })
      )
      }
    }

  },
  [commodityCode]
)
const pdiDisabled = usePdiEnable();
return (
  <Grid.Row>
    <CommodityField
      translate={translate}
      isFormDisabled={
        countryOfOrigin && destinationCountry
          ? !_.isEmpty(pdiDisabled)
            ? pdiDisabled.disabled
            : isFormDisabled
          : true
      }
      serviceType={serviceType}
      isImportShipment={isImportShipment}
      commodityCode={commodityCode}
      htsCode={htsCode}
      preferences={box36Preference}
      reduction={box36Reduction}
      invoiceId={invoiceId}
      submit={submit}
      taricCode={taricCode}
      merchandiseId={merchandiseId}
      htsMetaData={htsMetaData}
      showModal={showModal}
      countryOfOrigin={countryOfOrigin}
      destinationCountry={destinationCountry}
      htsEnabled={true}
      addError={addError}
      setShowModal={setShowModal}
      errors={getValidationError('commodityCode', htsCode, 'itemsTab')}
      onHtsChange={(value) => {
        updateData(invoiceId, merchandiseId, { htsCode: value, commodityCode: value })
      }}
      onTaricChange={(value) => {
        updateData(invoiceId, merchandiseId, {
          taricCode: value,
          commodityCode: htsCode + value,
        })
      }}
      onHtsPopupChange={(value) => {
        console.log(value)

        updateData(invoiceId, merchandiseId, value)
        saveData(merchandiseId, 'commodityCode', invoiceId)
      }}
      onBlur={() => {
        saveData(merchandiseId, 'commodityCode', invoiceId)
        let err = getValidationError('commodityCode', commodityCode, 'itemsTab')
        err.length
          ? addErrors(
              'itemsTab',
              `invoice - 00${invoiceIndex + 1} :: line ${lineItemIndex + 1}.` + ' :: ' + err[0],
              `commodityCode-${merchandiseId}`
            )
          : deleteErrors('itemsTab', '', `commodityCode-${merchandiseId}`)
      }}
    />
    <Grid.Column
      width={'3'}
      className={`divFormFeild  
             b-rw-0 
          `}
    >
      {' '}
      <InputField
        id={`taricCode1-${invoiceId}-${merchandiseId}`}
        label={translate('TARIC_ADDITIONAL_CODES_I', { ns: ['default', 'lineItem'] })}
        disabled={isFormDisabled}
        className='field-bg dropdown100'
        boxNumber='33.3'
        labelClass='text-none'
        isLabel={false}
        mandatory={false}
        direction={'right'}
        value={additionalCode1}
        errors={getValidationError('additionalCode1', additionalCode1, 'itemsTab')}
        onChange={(value) => {
          dispatch(updateLineItemFeild(invoiceId, merchandiseId, { additionalCode1: value }))
        }}
        onBlur={(value) => {
          dispatch(saveLineItemFeild(merchandiseId, 'additionalCode1', invoiceId))
          let err = getValidationError('additionalCode1', additionalCode1, 'itemsTab')
          err.length
            ? addErrors(
                'itemsTab',
                `invoice - 00${invoiceIndex + 1} :: line ${lineItemIndex + 1}.` + ' :: ' + err[0],
                `additionalCode1-${merchandiseId}`
              )
            : deleteErrors('itemsTab', '', `additionalCode1-${merchandiseId}`)
        }}
      />
    </Grid.Column>
    <Grid.Column
      width={'3'}
      className={`divFormFeild  b-rw-0
          `}
    >
      {' '}
      <InputField
        id={`taricCode2-${invoiceId}-${merchandiseId}`}
        label={translate('TARIC_ADDITIONAL_CODES_II', { ns: ['default', 'lineItem'] })}
        disabled={isFormDisabled}
        className='field-bg dropdown100'
        boxNumber='33.4'
        labelClass='text-none'
        isLabel={false}
        mandatory={false}
        value={additionalCode2}
        errors={getValidationError('additionalCode2', additionalCode2, 'itemsTab')}
        onChange={(value) => {
          dispatch(updateLineItemFeild(invoiceId, merchandiseId, { additionalCode2: value }))
        }}
        onBlur={(value) => {
          dispatch(saveLineItemFeild(merchandiseId, 'additionalCode2', invoiceId))
          let err = getValidationError('additionalCode2', additionalCode2, 'itemsTab')
          err.length
            ? addErrors(
                'itemsTab',
                `invoice - 00${invoiceIndex + 1} :: line ${lineItemIndex + 1}.` + ' :: ' + err[0],
                `additionalCode2-${merchandiseId}`
              )
            : deleteErrors('itemsTab', '', `additionalCode2-${merchandiseId}`)
        }}
      />
    </Grid.Column>
    <Grid.Column
      width='6'
      className={`divFormFeild b-rw-1 
          `}
    >
      {' '}
      <DropDown
        id={`exciseCode-${invoiceId}-${merchandiseId}`}
        label={translate('EXCISE_CODE', { ns: ['default', 'lineItem'] })}
        disabled={isFormDisabled}
        className='field-bg dropdown100'
        boxNumber={'33.5'}
        labelClass='text-none'
        isLabel={true}
        mandatory={false}
        direction={'right'}
        data={exciseCodes}
        value={exciseCode}
        clearable
        onChange={(value) => {
          dispatch(updateLineItemFeild(invoiceId, merchandiseId, { exciseCode: value?.trim() }))
          dispatch(saveLineItemFeild(merchandiseId, 'exciseCode', invoiceId))
        }}
      />
    </Grid.Column>
    <Grid.Column width={'3'} className='divFormFeild b-rw-0  '>
      <DropDown
        id={`countryOfOrigin-${invoiceId}-${merchandiseId}`}
        label={translate(COUNTRY_ORIGIN, { ns: ['default', 'lineItem'] })}
        disabled={isFormDisabled}
        {...pdiDisabled}
        className='field-bg dropdown100 addInfoCode'
        boxNumber='34.A'
        labelClass='text-none'
        isLabel={true}
        mandatory={false}
        direction={'right'}
        clearable
        data={specialCountryKeys}
        errors={getValidationError('countryOfOrigin', countryOfOrigin, 'itemsTab', true)}
        value={countryOfOrigin}
        onChange={(value) => {
          dispatch(
            updateLineItemFeild(invoiceId, merchandiseId, { countryOfOrigin: value?.trim() })
          )
          dispatch(saveLineItemFeild(merchandiseId, 'countryOfOrigin', invoiceId))
          let err = getValidationError('countryOfOrigin', value, 'itemsTab', true)
          err.length
            ? addErrors(
                'itemsTab',
                `invoice - 00${invoiceIndex + 1} :: line ${lineItemIndex + 1}.` + ' :: ' + err[0],
                `countryOfOrigin-${merchandiseId}`
              )
            : deleteErrors('itemsTab', '', `countryOfOrigin-${merchandiseId}`)
        }}
      />
    </Grid.Column>
    <Grid.Column width={'3'} className='divFormFeild b-rw-0  '>
      <DropDown
        id={`provinceOrigin-${invoiceId}-${merchandiseId}`}
        label={translate('PROVINCE_ORIGIN', { ns: ['default', 'lineItem'] })}
        disabled={isImportShipment ? true : isFormDisabled}
        className='field-bg dropdown100 addInfoCode'
        boxNumber='34.B'
        labelClass='text-none'
        isLabel={true}
        mandatory={false}
        direction={'right'}
        clearable
        data={originProvinceKeys}
        errors={
          !isImportShipment
            ? getValidationError('originProvince', originProvince, 'itemsTab', !isImportShipment)
            : console.log(isImportShipment)
        }
        value={originProvince}
        onChange={(value) => {
          dispatch(updateLineItemFeild(invoiceId, merchandiseId, { originProvince: value?.trim() }))
          dispatch(saveLineItemFeild(merchandiseId, 'originProvince', invoiceId))
          let err = getValidationError('originProvince', value, 'itemsTab', !isImportShipment)
          err.length
            ? addErrors(
                'itemsTab',
                `invoice - 00${invoiceIndex + 1} :: line ${lineItemIndex + 1}.` + ' :: ' + err[0],
                `originProvince-${merchandiseId}`
              )
            : deleteErrors('itemsTab', '', `originProvince-${merchandiseId}`)
        }}
      />
    </Grid.Column>
    <Grid.Column width='5' className='divFormFeild b-rw-0 '>
      <DropDown
        id={`Preference-${invoiceId}-${merchandiseId}`}
        label={translate(PREFERENCE, { ns: ['default', 'lineItem'] })}
        disabled={isFormDisabled || !isImportShipment}
        className='field-bg dropdown100 addInfoCode'
        boxNumber='36'
        labelClass='text-none'
        isLabel={true}
        mandatory={false}
        direction={'right'}
        clearable
        data={box36Preference}
        value={tariffRegime}
        errors={
          isImportShipment &&
          getValidationError('tariffRegime', tariffRegime, 'itemsTab', true, serviceType)
        }
        onChange={(value) => {
          dispatch(updateLineItemFeild(invoiceId, merchandiseId, { tariffRegime: value }))
          dispatch(
            saveLineItemFeild(merchandiseId, ['tariffRegimeSuffix', 'tariffRegime'], invoiceId)
          )
          let err = isImportShipment
            ? getValidationError('tariffRegime', value, 'itemsTab', true, serviceType)
            : []

          err.length
            ? addErrors(
                'itemsTab',
                `invoice - 00${invoiceIndex + 1} :: line ${lineItemIndex + 1}.` + ' :: ' + err[0],
                `tariffRegime-${merchandiseId}`
              )
            : deleteErrors('itemsTab', '', `tariffRegime-${merchandiseId}`)
        }}
      />
    </Grid.Column>
    <Grid.Column width='5' className={`divFormFeild b-rw-1 `}>
      <DropDown
        id={`reduction-${invoiceId}-${merchandiseId}`}
        label={translate(REDUCTION, { ns: ['default', 'lineItem'] })}
        disabled={isFormDisabled || !isImportShipment}
        className='field-bg dropdown100 addInfoCode'
        boxNumber='36'
        labelClass='text-none'
        isLabel={true}
        mandatory={false}
        direction={'left'}
        data={box36Reduction}
        clearable
        value={tariffRegimeSuffix}
        errors={
          isImportShipment &&
          getValidationError(
            'tariffRegimeSuffix',
            tariffRegimeSuffix,
            'itemsTab',
            true,
            serviceType
          )
        }
        onChange={(value) => {
          dispatch(
            updateLineItemFeild(invoiceId, merchandiseId, {
              tariffRegimeSuffix: value?.trim(),
            })
          )
          dispatch(
            saveLineItemFeild(merchandiseId, ['tariffRegimeSuffix', 'tariffRegime'], invoiceId)
          )
          let err = isImportShipment
            ? getValidationError('tariffRegimeSuffix', value, 'itemsTab', true, serviceType)
            : []
          err.length
            ? addErrors(
                'itemsTab',
                `invoice - 00${invoiceIndex + 1} :: line ${lineItemIndex + 1}.` + ' :: ' + err[0],
                `tariffRegimeSuffix-${merchandiseId}`
              )
            : deleteErrors('itemsTab', '', `tariffRegimeSuffix-${merchandiseId}`)
        }}
      />
    </Grid.Column>
  </Grid.Row>
)
}

export default  React.memo(MerchForm2);